import { BrowserRouter as Router, Navigate, Route, Routes } from "react-router-dom";
import { LoginPage } from "./pages/LoginPage";
import RecordsPage from "./pages/RecordsPage";
import ProfilePage from "./pages/ProfilePage";
import UploadPage from "./pages/UploadPage";
import { ProfileProvider } from "./context/ProfileContext";
import UsersPage from "./pages/UsersPage";
import EditUserPage from "./pages/EditUserPage";
import LogoutPage from "./pages/LogoutPage";
import { CacheProvider } from "./context/CacheContext";
import PowerPage from "./pages/PowerPage";
import TariffsPage from "./pages/TariffsPage";
import DebtsPage from "./pages/DebtsPage";
import MembershipPage from "./pages/MembershipPage";
import BillsPage from "./pages/BillsPage";
import HelpPage from "./pages/HelpPage";
import ErrorBoundary from "./pages/ErrorBoundary";
import TargetPage from "./pages/TargetPage";
import MessagesPage from "./pages/MessagesPage";
import RequisitePage from "./pages/RequisitePage";
import ManageHelpPage from "./pages/ManageHelpPage";
import ManageMessagesPage from "./pages/ManageMessagesPage";
import ManageRequisitePage from "./pages/ManageRequisitePage";
import ManageTelegramPage from "./pages/ManageTelegramPage";
import TelegramPage from "./pages/TelegramPage";
import { useEffect, useState } from "react";
import { API } from "./config";
import { Card, CardContent } from "./components/ui/card";

function App() {

  const [sensors, setSensors] = useState(['0', '0', '']);
  const [isOpen, setIsOpen] = useState((localStorage.getItem("sensorsOpen") ?? "true") === "true");

  let token = "";
  try {
    token = localStorage.getItem("token") || "";
  } catch (e) {
    console.error("Error reading token from localStorage:", e);
  }
  let page = "/message";
  try {
    page = localStorage.getItem("page") || "/message";
  } catch (e) {
    console.error("Error reading page from localStorage:", e);
  }

  const getSensors = () => async () => {
    if (!["localhost", "127.0.0.1", "ns2.kyiv.ua"].includes(window.location.hostname)) {
      return;
    }
    const res = await fetch(API.SENSORS, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });

    const data = await res.json();
    setSensors(data);
  };

  // useEffect(() => {
  //   getSensors()();
  //   if (["localhost", "127.0.0.1", "ns2.kyiv.ua"].includes(window.location.hostname)) {
  //     setInterval(getSensors(), 30000);
  //   }
  // }, []);

  useEffect(() => {
    localStorage.setItem("sensorsOpen", isOpen ? "true" : "false");
  }, [isOpen]);

  const toggleCard = () => {
    setIsOpen(!isOpen);
  }

  return (
    <ErrorBoundary name={"App"}>
      <CacheProvider>
        <ProfileProvider>
          {/*{["localhost", "127.0.0.1", "ns2.kyiv.ua"].includes(window.location.hostname) && (*/}
          {/*  <Card*/}
          {/*    className={`w-36 fixed top-0 z-50 transition-all duration-500 ease-in-out cursor-pointer ${*/}
          {/*      isOpen ? "right-0" : "MoveRight6Rem"*/}
          {/*    }`}*/}
          {/*    onClick={toggleCard}*/}
          {/*  >*/}
          {/*    <Card className={`absolute -left-3 top-1/3 w-8 h-8 flex items-center justify-center shadow-md bg-white right-0`}>*/}
          {/*      ⚡*/}
          {/*    </Card>*/}
          {/*    <CardContent className={`w-full text-center p-4 mb-0 ${*/}
          {/*      isOpen ? "w-full" : "w-full" */}
          {/*    }`}>*/}
          {/*      {sensors?.[0]} Вольт<br/>*/}
          {/*      {sensors?.[1]} Герц <br/>*/}
          {/*      {Number(sensors?.[2])/1000} ºC <br/>*/}
          {/*    </CardContent>*/}
          {/*  </Card>*/}
          {/*)}*/}
          <Router>
            <Routes>
              <Route path="/" element={<Navigate to={(token ? page : "/login") + window.location.search} replace/>}/>
              <Route path="/login" element={<LoginPage/>}/>
              <Route path="/logout" element={<LogoutPage/>}/>
              <Route path="/profile" element={<ProfilePage/>}/>
              <Route path="/tariffs" element={<TariffsPage/>}/>
              <Route path="/bills" element={<BillsPage/>}/>
              <Route path="/power" element={<PowerPage/>}/>
              <Route path="/debts" element={<DebtsPage/>}/>
              <Route path="/membership" element={<MembershipPage/>}/>
              <Route path="/target" element={<TargetPage/>}/>
              <Route path="/records" element={<RecordsPage/>}/>
              <Route path="/users" element={<UsersPage/>}/>
              <Route path="/user/:account" element={<EditUserPage/>}/>
              <Route path="/upload" element={<UploadPage/>}/>
              <Route path="/help" element={<HelpPage/>}/>
              <Route path="/message" element={<MessagesPage/>}/>
              <Route path="/requisite" element={<RequisitePage/>}/>
              <Route path="/telegram" element={<TelegramPage/>}/>
              <Route path="/manage/message" element={<ManageMessagesPage/>}/>
              <Route path="/manage/requisite" element={<ManageRequisitePage/>}/>
              <Route path="/manage/help" element={<ManageHelpPage/>}/>
              <Route path="/manage/telegram" element={<ManageTelegramPage/>}/>
            </Routes>
          </Router>
        </ProfileProvider>
      </CacheProvider>
    </ErrorBoundary>
  );
}

export default App;
